var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"qrcode-wrap"}},[_c('div',[_c('div',{ref:"qrCodeUrl",staticClass:"qrcode"}),_vm._v(" "),_c('h3',[_vm._v("用谷歌验证器绑定后-返回页面，重新登录")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e2cfada","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/qrCode.vue
// module id = null
// module chunks = 